module.exports = __webpack_public_path__ + "img/pd-img-body9.93e25db9.png";